export default "__VITE_ASSET__CzcgoPJs__"